module.exports = __webpack_public_path__ + "static/media/CAMARONSOYA_MENU-normal.b90309e2.png";